import "core-js/modules/es.array.concat";
import _classCallCheck from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _getPrototypeOf from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/get";
import _createSuper from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/input/inputview
 */
import View from '../view';
import FocusTracker from '@ckeditor/ckeditor5-utils/src/focustracker';
import '../../theme/components/input/input.css';
/**
 * The base input view class.
 *
 * @extends module:ui/view~View
 */

var InputView = /*#__PURE__*/function (_View) {
  _inherits(InputView, _View);

  var _super = _createSuper(InputView);

  /**
   * @inheritDoc
   */
  function InputView(locale) {
    var _this;

    _classCallCheck(this, InputView);

    _this = _super.call(this, locale);
    /**
     * The value of the input.
     *
     * @observable
     * @member {String} #value
     */

    _this.set('value');
    /**
     * The `id` attribute of the input (i.e. to pair with a `<label>` element).
     *
     * @observable
     * @member {String} #id
     */


    _this.set('id');
    /**
     * The `placeholder` attribute of the input.
     *
     * @observable
     * @member {String} #placeholder
     */


    _this.set('placeholder');
    /**
     * Controls whether the input view is in read-only mode.
     *
     * @observable
     * @member {Boolean} #isReadOnly
     */


    _this.set('isReadOnly', false);
    /**
     * Set to `true` when the field has some error. Usually controlled via
     * {@link module:ui/labeledinput/labeledinputview~LabeledInputView#errorText}.
     *
     * @observable
     * @member {Boolean} #hasError
     */


    _this.set('hasError', false);
    /**
     * The `id` of the element describing this field, e.g. when it has
     * some error; it helps screen readers read the error text.
     *
     * @observable
     * @member {Boolean} #ariaDescribedById
     */


    _this.set('ariaDescribedById');
    /**
     * Stores information about the editor UI focus and propagates it so various plugins and components
     * are unified as a focus group.
     *
     * @readonly
     * @member {module:utils/focustracker~FocusTracker} #focusTracker
     */


    _this.focusTracker = new FocusTracker();
    /**
     * An observable flag set to `true` when the input is currently focused by the user.
     * Set to `false` otherwise.
     *
     * @readonly
     * @observable
     * @member {Boolean} #isFocused
     * @default false
     */

    _this.bind('isFocused').to(_this.focusTracker);
    /**
     * An observable flag set to `true` when the input contains no text, i.e.
     * when {@link #value} is `''`, `null`, or `false`.
     *
     * @readonly
     * @observable
     * @member {Boolean} #isEmpty
     * @default true
     */


    _this.set('isEmpty', true);
    /**
     * Corresponds to the `inputmode` DOM attribute. Can be `text`, `numeric`, `decimal`, etc.
     *
     * @observable
     * @member {Boolean} #inputMode
     * @default 'text'
     */


    _this.set('inputMode', 'text');

    var bind = _this.bindTemplate;

    _this.setTemplate({
      tag: 'input',
      attributes: {
        class: ['ck', 'ck-input', bind.if('isFocused', 'ck-input_focused'), bind.if('isEmpty', 'ck-input-text_empty'), bind.if('hasError', 'ck-error')],
        id: bind.to('id'),
        placeholder: bind.to('placeholder'),
        readonly: bind.to('isReadOnly'),
        inputmode: bind.to('inputMode'),
        'aria-invalid': bind.if('hasError', true),
        'aria-describedby': bind.to('ariaDescribedById')
      },
      on: {
        input: bind.to(function () {
          var _this2;

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          (_this2 = _this).fire.apply(_this2, ['input'].concat(args));

          _this._updateIsEmpty();
        }),
        change: bind.to(_this._updateIsEmpty.bind(_assertThisInitialized(_this)))
      }
    });
    /**
     * Fired when the user types in the input. Corresponds to the native
     * DOM `input` event.
     *
     * @event input
     */


    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(InputView, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      _get(_getPrototypeOf(InputView.prototype), "render", this).call(this);

      this.focusTracker.add(this.element);

      this._setDomElementValue(this.value);

      this._updateIsEmpty(); // Bind `this.value` to the DOM element's value.
      // We cannot use `value` DOM attribute because removing it on Edge does not clear the DOM element's value property.


      this.on('change:value', function (evt, name, value) {
        _this3._setDomElementValue(value);

        _this3._updateIsEmpty();
      });
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(InputView.prototype), "destroy", this).call(this);

      this.focusTracker.destroy();
    }
    /**
     * Moves the focus to the input and selects the value.
     */

  }, {
    key: "select",
    value: function select() {
      this.element.select();
    }
    /**
     * Focuses the input.
     */

  }, {
    key: "focus",
    value: function focus() {
      this.element.focus();
    }
    /**
     * Updates the {@link #isEmpty} property value on demand.
     *
     * @private
     */

  }, {
    key: "_updateIsEmpty",
    value: function _updateIsEmpty() {
      this.isEmpty = isInputElementEmpty(this.element);
    }
    /**
     * Sets the `value` property of the {@link #element DOM element} on demand.
     *
     * @private
     */

  }, {
    key: "_setDomElementValue",
    value: function _setDomElementValue(value) {
      this.element.value = !value && value !== 0 ? '' : value;
    }
  }]);

  return InputView;
}(View);

export { InputView as default };

function isInputElementEmpty(domElement) {
  return !domElement.value;
}